
import React from "react";
import {Modal2} from "../modal";
import {Action, TextLoading} from "../../funcs/utils";
import {getRGB} from "../../../lib/color";

const dump_pair = (left, right, index, selected_index, color, on_click, is_mobile) => {
  const style = {
    display: "flex",
    color,
  }
  if (is_mobile && index !== selected_index) {
    style.cursor = "pointer";
  }
  return (
    <div style={style} key={index} onClick={on_click}>
      <div style={{flex: "1"}}>
        { left }
      </div>
      <div style={{flex: "1"}}>
        { right }
      </div>
    </div>
  )
}

const AddNewAccountDialog = props => {
  const {component, menu_data, adding_account, on_add_account } = props;

  const cancel_button = {
    id: "cancel",
    label: "Cancel",
    cb: () => {
      component.setState({
        show_add_account_dialog: false,
      })
    },
  }

  const add_button = {
    id: "add",
    label: (
      <TextLoading
        label={"Add Account"}
        loading={adding_account}/>),
    cb: () => on_add_account(),
  }

  const mk_action = button => {
    const style = {
      padding: "0.2rem 1rem",
    }
    return (
      <Action style={style} onClick={button.cb}>
        { button.label }
      </Action>
    )
  }

  const container_style = {
    width: "30rem",
    fontSize: "1rem",
  }

  const hr_style = {
    height: "1px",
    margin: "0",
    backgroundColor: "#000",
  }

  const text_style = {
    fontWeight: "bold",
  }

  const acct_items = menu_data.map((item, index) => {
    const color = props.acct_index === index
      ? getRGB(props.client.color.sign_on_button) : "#000";

    const on_click = () => {
      if (props.isMobile && index !== props.acct_index) {
        props.on_select_index(index);
      }
    }
    return dump_pair(
      (<span style={text_style}>{item.account}</span>),
      (<span style={text_style}>{item.type}</span>),
      index, props.acct_index, color, on_click, props.isMobile);
  });

  const center_style = {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
  }

  return (
    <Modal2
      noFooter={true}
      header_style={{padding: "0"}}
      container_style={container_style}>
      {dump_pair("Current Account", "Type", "header")}
      <hr style={hr_style}/>
      {acct_items}
      <div style={{height: "1.5rem"}}/>
      <div style={{ display: "flex",  position: "relative", flexDirection: "row-reverse"}}>
        <div>
          { mk_action(cancel_button)}
        </div>
        <div style={center_style}>
          { mk_action(add_button) }
        </div>
      </div>
    </Modal2>
  );
}

export {AddNewAccountDialog};
